import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { paths } from "../routes/paths";
import Loader from "../components/loader";
import Layout from "../layouts/layout";
import SideMenu from "../components/sideMenu";
import COUPONS from "../api/services/COUPONS";
import { TagSvg } from "../svgs/tagSvg";
import styles from "../styles/_screens/coupons.module.scss";
import Table from "../containers/_couponsUsageHistory/table";

const CouponUsageHistory = () => {
  const [data, setData] = useState(null);
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [totalPages, setTotalPages] = useState(1);

  const navigate = useNavigate();

  // FETCH COUPONS USAGE HISTORY
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await COUPONS.get_coupons_usage_history(page, size);
        if (page === 1) {
          setData(res.history);
        } else {
          setData((prev) => [...prev, ...res.history]);
        }
        setTotalPages(res.totalPages);
      } catch (error) {
        console.log(error);
      }
    };

    fetchData();
  }, [page, size]);

  const sideMenuList = [
    {
      id: 1,
      svg: <TagSvg fill="#000000" />,
      text: "קופונים",
      active: false,
      onClick: () => navigate(paths.coupons),
    },
    {
      id: 2,
      svg: <TagSvg fill="#DE1468" />,
      text: "היסטוריית שימוש",
      active: true,
    },
  ];

  if (!data) {
    return (
      <Layout>
        <div className={styles.container}>
          <div className={styles.wrapper}>
            <div className={styles.main}>
              <Loader />
            </div>
          </div>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className={styles.container}>
        <div className={styles.wrapper}>
          {/* SIDE MENU */}
          <SideMenu list={sideMenuList} />
          <div className={styles.main}>
            <Table data={data} />
            {page < totalPages && (
              <button className={styles.button} onClick={() => setPage((prev) => prev + 1)}>
                load more
              </button>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default CouponUsageHistory;
